export default "__VITE_ASSET__268489c7__"